import { atom } from 'jotai';

export const nickNameUpdateMessageAtom = atom('');

export const nickNameUpdateHasErrorAtom = atom(false);
